"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _icons = require("../../toolkit/icons");

var _localization = require("../../toolkit/localization");

//
//  ExpanderButton.tsx
//  Project-Lego
//
//  Created by Chiyi Wang on 01/09/20.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  expanded: {
    required: true,
    type: "boolean",
    description: "whether the button is in expanded state"
  },
  onClick: {
    required: true,
    type: "() => void",
    description: "callback handler when the button is clicked"
  }
};
var demoProps = {
  expanded: false,
  onClick: function onClick() {}
};

var ExpanderButton = function ExpanderButton(props) {
  var expanded = props.expanded,
      _onClick = props.onClick,
      popoverContent = props.popoverContent,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["expanded", "onClick", "popoverContent", "children"]);

  var _useLocalization = (0, _localization.useLocalization)(),
      i18n = _useLocalization.i18n;

  var hint = expanded ? i18n("Click to collapse") : i18n("Click to expand");
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    popoverContent: popoverContent === undefined ? hint : popoverContent,
    icon: expanded ? _icons.remove : _icons.add,
    onClick: function onClick() {
      return _onClick(expanded);
    }
  }, otherProps), children);
};

ExpanderButton.propDoc = propDoc;
ExpanderButton.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(ExpanderButton);

exports["default"] = _default;